const ABDMActionNames = {
    SAVE_PATIENT_CREATE_INFO: "SAVE_PATIENT_CREATE_INFO",
    SAVE_PATIENT_CREATE_AADHAAR_VERIFY: "SAVE_PATIENT_CREATE_AADHAAR_VERIFY",
    SAVE_PATIENT_CREATE_MOBILE_VERIFY: "SAVE_PATIENT_CREATE_MOBILE_VERIFY",
    SAVE_PATIENT_LINK_INFO: "SAVE_PATIENT_LINK_INFO",
    SAVE_PATIENT_LINK_MOBILE_VERIFY: "SAVE_PATIENT_CREATE_LINK_VERIFY"
}


export default ABDMActionNames;